import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'bb-hubspot',
	templateUrl: './bb-hubspot.component.html'
})

export class BbHubspotComponent implements OnInit {
	@Input() label: string;

	title = '';

	constructor(
		private translate: TranslateService) {
	}

	ngOnInit() {
		this.title = this.translate.instant('CONTACT_SUPPORT');
	}
}
